
















































































































































































































































































































































































































































import { MessageService } from "@/shared/services/message-service";
import { Component, Vue, Watch } from "vue-property-decorator";

// Importación del Módulo Vuex instanciado
import ui_logsModule from "@/store/modules/ui_logs-module";

// DTOs
import { ui_log_entry } from "@/shared/dtos/logs/ui_log_entry";
import { ui_logs_query_request } from "@/shared/dtos/logs/ui_logs_query_request";
import { ui_log_incident_group } from "@/shared/dtos/logs/ui_log_incident_group";

// DevExtreme Imports
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxFilterRow,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";

@Component({
  name: "LogsViewer",
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxHeaderFilter,
  },
})
export default class LogsViewer extends Vue {
  // Estado local
  public loading: boolean = false;
  public analysisMode: boolean = false;
  public realTimeActive: boolean = false;
  private realTimeInterval: any = null;
  public menuDate: boolean = false;

  // Diálogo de detalle
  public showDetailDialog: boolean = false;
  public selectedLog: ui_log_entry | null = null;

  // Resultado del análisis local
  public analyzedGroups: ui_log_incident_group[] = [];

  // Filtros
  public filters = {
    dates: [] as string[],
    dateRangeText: "",
    level: "Todos",
    search: "",
  };

  public dateFormat: string = "yyyy-MM-dd HH:mm:ss";

  // -------- GETTERS (Vuex) --------
  // Accedemos directamente a las propiedades del módulo tipado
  public get logs(): ui_log_entry[] {
    return ui_logsModule.logs;
  }

  public get stats() {
    return ui_logsModule.stats;
  }

  // -------- LIFECYCLE --------
  public mounted() {
    // Inicializar fechas: últimos 7 días
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 7);

    this.filters.dates = [
      start.toISOString().substr(0, 10),
      end.toISOString().substr(0, 10),
    ];

    this.updateDateText();
    this.loadLogs();
  }

  public beforeDestroy() {
    this.stopRealTime();
  }

  // -------- WATCHERS --------
  @Watch("filters.dates")
  public updateDateText() {
    if (!this.filters.dates || this.filters.dates.length === 0) {
      this.filters.dateRangeText = "";
      return;
    }
    // Ordenar visualmente para que la fecha menor salga primero en el texto
    const sorted = [...this.filters.dates].sort();
    this.filters.dateRangeText = sorted.join(" ~ ");
  }

  @Watch("analysisMode")
  public onAnalysisModeChanged() {
    if (this.analysisMode) {
      this.runAnalysisAlgorithm();
    }
  }

  // -------- DATA LOAD --------
  public async loadLogs() {
    this.loading = true;

    try {
      // Ordenar fechas para enviar al backend (from < to)
      const sortedDates = this.filters.dates
        ? [...this.filters.dates].sort()
        : [];

      const from = sortedDates[0]
        ? new Date(sortedDates[0]).toISOString()
        : null;
      // Ajustar "to" al final del día
      const to = sortedDates[1]
        ? new Date(sortedDates[1] + "T23:59:59").toISOString()
        : null;

      const req = new ui_logs_query_request();
      req.take = 1000; // Traer suficientes registros para analizar
      req.contains = this.filters.search || null;
      req.fromUtc = from;
      req.toUtc = to;
      req.level =
        this.filters.level && this.filters.level !== "Todos"
          ? this.filters.level
          : null;

      // Llamada al Action del Módulo
      await ui_logsModule.queryui_logs(req);

      // Si estamos en modo análisis, recalcular grupos con los nuevos datos
      if (this.analysisMode) {
        this.runAnalysisAlgorithm();
      } else {
        this.analyzedGroups = [];
      }
    } catch (e) {
      console.error(e);
      MessageService.alert(
        "Error",
        "No se pudieron cargar los logs. Verifique la conexión.",
        MessageService.TypeError
      );
    } finally {
      this.loading = false;
    }
  }

  // -------- REAL TIME --------
  public toggleRealTime() {
    this.realTimeActive = !this.realTimeActive;
    if (this.realTimeActive) {
      this.startRealTime();
    } else {
      this.stopRealTime();
    }
  }

  private startRealTime() {
    this.stopRealTime();
    // Refresco cada 5 segundos
    this.realTimeInterval = setInterval(() => {
      this.loadLogs();
    }, 5000);

    MessageService.toast("Monitoreo en tiempo real activado (5s)");
  }

  private stopRealTime() {
    if (this.realTimeInterval) {
      clearInterval(this.realTimeInterval);
      this.realTimeInterval = null;
    }
  }

  // -------- ALGORITMO DE ANÁLISIS (Local) --------
  // Agrupa logs por TraceID o por firma de excepción para reducir ruido
  public runAnalysisAlgorithm() {
    const src = this.logs || [];
    if (src.length === 0) {
      this.analyzedGroups = [];
      return;
    }

    // Filtramos solo lo relevante (Errores y Warnings)
    const errorLogs = src.filter((l) => {
      if (!l.level) return false;
      return ["Error", "Critical", "Warning"].includes(l.level);
    });

    const groups: { [key: string]: ui_log_incident_group } = {};

    for (const log of errorLogs) {
      let groupKey = "";

      // 1. Prioridad: Trace ID (Hilo completo)
      if (log.trace_id && log.trace_id !== "00000000000000000000000000000000") {
        groupKey = "TRACE::" + log.trace_id;
      }
      // 2. Prioridad: Excepción (Mismo error repetido)
      else if (log.exception) {
        const signature = log.exception.substring(0, 150).trim(); // Firma más larga para precisión
        groupKey = "EX::" + signature;
      }
      // 3. Fallback: Mensaje
      else {
        groupKey = "MSG::" + (log.message || "Unknown");
      }

      // Crear grupo si no existe
      if (!groups[groupKey]) {
        const g = new ui_log_incident_group();
        g.count = 0;
        g.lastOccurrence = log.utc;
        g.logs = [];
        g.exception = log.exception || null;

        if (groupKey.startsWith("TRACE::")) {
          const shortTrace = log.trace_id ? log.trace_id.substring(0, 8) : "";
          g.title = `Hilo de transacción fallido (Trace: ${shortTrace}...)`;
          g.subtitle = log.message || "Error en transacción distribuida";
        } else if (groupKey.startsWith("EX::")) {
          const exName = log.exception
            ? log.exception.split(":")[0]
            : "Error de Aplicación";
          g.title = `Excepción Recurrente: ${exName}`;
          g.subtitle = `Ubicación: ${log.category || "Desconocida"}`;
        } else {
          g.title = log.message || "Error sin detalle";
          g.subtitle = log.category || "";
        }

        groups[groupKey] = g;
      }

      // Agregar log al grupo
      groups[groupKey].logs.push(log);
      groups[groupKey].count++;

      // Actualizar fecha del último suceso
      if (log.utc > groups[groupKey].lastOccurrence) {
        groups[groupKey].lastOccurrence = log.utc;
      }
    }

    // Convertir a array y ordenar por fecha (más reciente arriba)
    const arr = Object.values(groups);
    arr.sort((a, b) => {
      const ta = new Date(a.lastOccurrence).getTime();
      const tb = new Date(b.lastOccurrence).getTime();
      return tb - ta;
    });

    this.analyzedGroups = arr;
  }

  // -------- UI HELPERS --------

  public openDetail(log: ui_log_entry) {
    this.selectedLog = log;
    this.showDetailDialog = true;
  }

  public closeDetail() {
    this.showDetailDialog = false;
    setTimeout(() => {
      this.selectedLog = null;
    }, 300);
  }

  public getLevelClass(level: string) {
    switch (level) {
      case "Error":
        return "red--text font-weight-bold";
      case "Critical":
        return "red--text text--darken-4 font-weight-black";
      case "Warning":
        return "orange--text text--darken-2 font-weight-bold";
      case "Information":
        return "blue--text text--darken-2";
      default:
        return "grey--text";
    }
  }

  public getColor(level: string) {
    switch (level) {
      case "Error":
        return "red";
      case "Critical":
        return "red darken-4";
      case "Warning":
        return "orange darken-2";
      case "Information":
        return "info";
      default:
        return "grey";
    }
  }

  public getIcon(level: string) {
    switch (level) {
      case "Error":
        return "error_outline";
      case "Critical":
        return "gavel";
      case "Warning":
        return "warning";
      case "Information":
        return "info_outline";
      default:
        return "notes";
    }
  }

  public formatTime(utc: string) {
    if (!utc) return "";
    return new Date(utc).toLocaleTimeString();
  }

  public formatDate(utc: string) {
    if (!utc) return "";
    return new Date(utc).toLocaleString();
  }

  public formatJson(obj: any) {
    try {
      if (obj === null || obj === undefined) return "{}";
      if (typeof obj === "string") return obj; // Ya es string
      return JSON.stringify(obj, null, 2);
    } catch {
      return "{}";
    }
  }
}
